var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-full w-screen"},[(_vm.isLoading)?_c('LoadingState'):_vm._e(),_c('Container',[_c('GlofoxPortal',{attrs:{"source":_vm.timetableSource},on:{"loaded":function($event){_vm.isLoading=false}}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }